{
  "login": {
    "title": "سجل الدخول إلى حسابك في مسافر",
    "description": "أدخل بيانات حسابك للمتابعة.",
    "identifier": "البريد الإلكتروني أو اسم المستخدم",
    "password": "كلمة المرور",
    "submit": "تسجيل الدخول",
    "submitting": "جاري تسجيل الدخول...",
    "forgot": "نسيت كلمة المرور؟",
    "orContinueWith": "أو المتابعة باستخدام",
    "withNfc": "تسجيل الدخول باستخدام NFC",
    "errors": {
      "invalidCredentials": "اسم المستخدم أو كلمة المرور غير صحيحة",
      "accountLocked": "تم قفل الحساب مؤقتا بسبب محاولات كثيرة. حاول مجددا بعد 15 دقيقة.",
      "accountLockedUntil": "تم قفل الحساب مؤقتا بسبب محاولات كثيرة. حاول مجددا بعد الساعة {{time}}.",
      "accountInactive": "الحساب غير نشط، تواصل مع المسؤول",
      "accountPending": "لم يكتمل تسجيل هذا الحساب بعد. تواصل مع المسؤول للحصول على رابط إكمال تسجيل جديد.",
      "network": "تعذر الاتصال بالخادم. تحقق من الاتصال وحاول مجددا."
    }
  },
  "nfc": {
    "title": "تسجيل الدخول ببطاقة NFC",
    "description": "يرجى تمرير بطاقة NFC على القارئ",
    "waiting": "في انتظار بطاقة NFC...",
    "detected": "تم اكتشاف البطاقة! جاري التحقق...",
    "cancel": "إلغاء"
  },
  "forgotPassword": {
    "title": "نسيت كلمة المرور",
    "description": "أدخل اسم المستخدم أو البريد الإلكتروني لإرسال رابط إعادة التعيين.",
    "submit": "إرسال",
    "sent": "إذا كان بريدك موثقا، وصلك رابط إعادة التعيين. غير ذلك، تواصل مع المسؤول.",
    "backToLogin": "العودة إلى تسجيل الدخول"
  },
  "setPassword": {
    "setupTitle": "إكمال التسجيل",
    "resetTitle": "تعيين كلمة المرور",
    "loading": "جاري التحميل...",
    "new": "كلمة المرور الجديدة",
    "confirm": "تأكيد كلمة المرور",
    "current": "كلمة المرور الحالية",
    "submit": "حفظ",
    "success": "تم حفظ كلمة المرور بنجاح",
    "mismatch": "كلمتا المرور غير متطابقتين",
    "required": "هذا الحقل مطلوب",
    "tooShort": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    "equalsUsername": "لا يمكن أن تكون كلمة المرور مطابقة لاسم المستخدم",
    "strength": {
      "weak": "ضعيفة",
      "fair": "مقبولة",
      "good": "جيدة",
      "strong": "قوية"
    }
  },
  "selectBranch": {
    "title": "اختيار الفرع",
    "description": "اختر الفرع الذي تعمل فيه.",
    "branch": "الفرع",
    "placeholder": "اختر فرع...",
    "confirm": "تأكيد الاختيار",
    "noBranch": "لا توجد صلاحية على أي فرع، تواصل مع المسؤول"
  },
  "action": {
    "backToLogin": "العودة إلى تسجيل الدخول"
  }
}
